import { render, staticRenderFns } from "./MyArticle.vue?vue&type=template&id=65f5fc16&scoped=true&"
import script from "./MyArticle.vue?vue&type=script&lang=js&"
export * from "./MyArticle.vue?vue&type=script&lang=js&"
import style0 from "./MyArticle.vue?vue&type=style&index=0&id=65f5fc16&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5fc16",
  null
  
)

export default component.exports